import script from "./BreadCrumb.vue?vue&type=script&setup=true&lang=js"
export * from "./BreadCrumb.vue?vue&type=script&setup=true&lang=js"

import "./BreadCrumb.vue?vue&type=style&index=0&id=648c289b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-648c289b"]])

export default __exports__